import { IWhitePaperReport, UserClaims } from '../model';

export const WHITEPAPER_CACHE_STORE_NAME = 'WhitePaperCache';
export const DB_WHITEPAPERREPORT_NAME = 'WhitePaperReportDB';

export interface IWhitePaperReportCacheRecord {
    id: string;
    returnKey: string;
    reportData: string;
    versionId?: string;
    timestamp: number;
}

export const adaptWhitePaperReportToCacheRecord = (
    returnKey: string,
    reportData: IWhitePaperReport,
    enterpriseId?: string,
    versionId?: string
): IWhitePaperReportCacheRecord => {
    return {
        id: getWhitePaperReportRecordId(returnKey, enterpriseId, versionId),
        returnKey: returnKey.toString(),
        reportData: JSON.stringify(reportData),
        versionId: versionId || '',
        timestamp: Date.now(),
    };
};

export const parseWhitePaperReportFromCache = (cacheRecord: IWhitePaperReportCacheRecord): IWhitePaperReport | null => {
    return JSON.parse(cacheRecord.reportData) as IWhitePaperReport;
};

export const getWhitePaperCacheStoreName = (userClaims?: UserClaims): string | null => {
    if (!userClaims) {
        return null;
    }

    return `${WHITEPAPER_CACHE_STORE_NAME}_${userClaims.environmentName}_${userClaims.userId}`;
};

export const getWhitePaperReportRecordId = (returnKey: string, enterpriseId?: string, versionId?: string): string => {
    let recordId = `whitepaper-report-${returnKey}`;
    if (enterpriseId) {
        recordId += `-${enterpriseId}`;
    }
    if (versionId) {
        recordId += `-${versionId}`;
    }
    return recordId;
};

export const whitePaperIndexedDBSchema = (db: IDBDatabase, storeName: string) => {
    const objectStore = db.createObjectStore(storeName, { keyPath: 'id' });
    objectStore.createIndex('returnKey', 'returnKey', { unique: false });
};
